import angular from 'angular';

import Listing from '../listing/index';
import SellerData from '../sellerData/index';

import Browser from 'cars-ng-browser';
import User from 'cars-ng-user';
import Tracking from 'cars-ng-tracking';

import serversideLeadform from './leadForm.serverside.component.js';
import service from './leadForm.service';
import leadFormModelService from './leadFormModel.service';
import DealerChat from '../dealerChat/index';
import CarsNgActiveTest from '../carsNgActiveTest';
import CarsNgEmployees from 'cars-ng-employees';
import vdpStatTrackingService from '../vdpStatTrackingService/index';
import postLeadSurveyService from '../postLeadSurvey/index';

export default angular.module('vdp.leadForm', [
    Browser,
    DealerChat,
    Listing,
    SellerData,
    Tracking,
    User,
    CarsNgActiveTest,
    CarsNgEmployees,
    vdpStatTrackingService,
    postLeadSurveyService,
])

.directive('carsVdpServersideLeadForm', ['$rootScope', '$compile', 'listingService', 'leadFormModelService', 'employeeReviewsModalService', 'userDataService', 'leadFormService', 'sellerService', 'dataBrokerService', 'dealerChatService', 'viewport', serversideLeadform])
.service('leadFormService', service)
.service('leadFormModelService', leadFormModelService)

.name;
